import React from "react";
import { RadioButton } from "primereact/radiobutton";
import { Controller } from "react-hook-form";

const CommonRadioGroup = ({
  name,
  label,
  options,
  validationFn,
  value,
  onChange,
  register,
  control,
  errors,
  defaultValue
}) => {
  return (
    <div className="radio-group-container">
      <label htmlFor={name} className="fw-bold secondary-text-color mb-3">
        {label}
      </label>
      <div className="radio-options d-flex flex-wrap">
        {options.map((option, index) => (
          <div
            key={option.value}
            style={{
              display:'flex',
              alignItems:'end',
              justifyContent:'flex-start',
            }}
            className={`radio-option-container ${
              index < 1 ? "half-width" : "full-width mt-2"
            }`}
          >
            <Controller
              name={name}
              control={control}
              defaultValue={defaultValue===true ? '' : index === 0 ? option.value : ""}
              rules={{
                validate: (value) => {
                  const { errorFlag, error } = validationFn({
                    FieldName: name,
                    value,
                  });
                  if (errorFlag) {
                    return error;
                  }
                  return true;
                },
              }}
              render={({ field }) => (
                <>
                 <div className=""style={{display:'flex',}}>
                    <RadioButton style={{alignSelf:'center'}} 
                     inputId={`${name}_${option.value}`}  value={option.value} onChange={(e) => field.onChange(e.value)} checked={field.value === option.value} />
                  <label
                  style={{
                    padding:2
                  }}
                    htmlFor={`${name}_${option.value}`}
                    className="radio-label primary-text-color mt-1"
                  >
                    {option.label}
                  </label>
                  </div>
                </>
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonRadioGroup;


